// extracted by mini-css-extract-plugin
export default {"space30":"index_space30_nJCPO","col_w1000":"index_col_w1000_-FlQX"};